import { createApi } from "@reduxjs/toolkit/query/react";

import { baseQuery } from "@tsp-core/store/utils";

import { CountryUuid } from "@tsp-domains/countries/types";
import { CurrencyId } from "@tsp-domains/money/enums";

import { PaymentSystemCountryCurrencyRules } from "../types";

type GetCountryCurrencyListResponseData = {
  rules: Array<{
    currencyId: CurrencyId;
    countryUuid: CountryUuid;
  }>;
};

export const paymentSystemApi = createApi({
  reducerPath: "@payment-system/api",
  baseQuery,
  refetchOnFocus: false,
  refetchOnReconnect: false,
  refetchOnMountOrArgChange: false,
  keepUnusedDataFor: 60 * 60 * 24,
  endpoints: (builder) => ({
    getCountryCurrencyList: builder.query<PaymentSystemCountryCurrencyRules, void>({
      query: () => ({
        url: "/payment-system/settings/country-currency-list",
        method: "GET",
      }),
      transformResponse: (response: GetCountryCurrencyListResponseData): PaymentSystemCountryCurrencyRules => {
        return response.rules.map((rule) => ({
          currencyId: rule.currencyId,
          countryUuid: rule.countryUuid,
        }));
      },
    }),
  }),
});
